export const homePath = "/";
export const dashboard = "/dashboard";
export const authPath = "/auth";
export const finishedStreamsPath = "/finished";
export const webWalletTxReturnPath = "webtxresult";
export const streamPath = (streamId: number) => `stream/${streamId}`;
export const streamNotFoundPath = "/stream/not-found";
